module.exports = __webpack_public_path__ + "img/coconala_merit3.d8dc5db.jpg";